import Link from 'next/link';
import React from 'react';

export default function CategoriesDropdown(value) {
	return (
		<a href={value.value.attributes.slug=='padhaai'?'/bits/padhaai-bits':`/category/${value.value.attributes.slug}`} className='text-sm font-semibold text-white block mb-3 sm:text-left text-center sm:p-0 py-3'>{value.value.attributes.name}</a>
	);
}
